import React from 'react';
import { twMerge } from 'tailwind-merge';
import { Avatar } from '@components/basics/Images/Avatar';
import { TABLET_COVER_SIZE } from '../components/shared';

export const ToggledAvatar = ({
  src,
  username,
  walletAddress,
  userWebappUri,
  forceMobileView = false,
}: {
  src?: string;
  username: string;
  walletAddress: string;
  userWebappUri: string;
  forceMobileView?: boolean;
}) => {
  return (
    <div
      className={twMerge(
        'mr-2 inline-flex h-10 w-10 flex-shrink-0 overflow-hidden rounded-full md:h-12 md:w-12',
        !forceMobileView && 'lg:hidden',
      )}
    >
      <Avatar
        src={src}
        username={username}
        walletAddress={walletAddress}
        size={TABLET_COVER_SIZE}
        borderRadius={8}
        webappUri={userWebappUri}
      />
    </div>
  );
};
